import * as ids from 'short-id';
import { PodcastTemplateConfig } from 'redux/middleware/api/podcast-service';
import { Layer, LayerState } from '../types';

// template gets passed in with an array describing the layer order, e.g.
// ['text', 'text', 'media', 'waveform'], etc.  Assets in the template reference
// these indexes.  This function replaces each layer string with an id.
//
// the configuration will also contain audio layers, which are not handled by the
// VideoTemplateEditor and so are filtered out
export function identifyLayers(config: PodcastTemplateConfig): Layer[] {
  const { layerOrder } = config;

  return layerOrder.reduce((acc, layer, i, ary) => {
    // TODO waveform doesn't need a special id
    if (layer === 'waveform') {
      const existingWaveformLayer = acc.find(l => l.type === 'waveform');

      if (existingWaveformLayer) {
        throw new Error(
          'Invalid layer order - found multiple "waveform" layers',
        );
      } else {
        acc.push({ id: 'waveform', type: layer });
      }
    } else if (layer !== 'audio') {
      acc.push({ id: ids.generate(), type: layer });
    } else {
      const nextLayer = ary[i + 1];

      if (nextLayer !== 'audio' && i + 1 < ary.length) {
        throw new Error(
          'Invalid layer order - found "audio" layer that is not at the end of the layer list',
        );
      }
    }

    return acc;
  }, []);
}

export function buildLayerState(layers: Layer[]): LayerState {
  const data = layers.reduce((acc, layer) => {
    acc[layer.id] = layer;
    return acc;
  }, {});

  const order = layers.map(l => l.id);

  return { data, order };
}
